import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import type { ControlInfo } from 'Router';

export default function useNotifyInfo(controlData: ControlInfo[] | null) {
  useEffect(() => {
    if (!controlData) return;

    controlData.find((data) => {
      if (data.app_name === 'ServerTools') {
        const currentDate = new Date().getTime();

        if (
          currentDate >= data.start_date &&
          (!data.end_date || currentDate <= data.end_date)
        ) {
          enqueueSnackbar(data.message || '', {
            persist: true,
            title: data.title,
            variant: 'info',
          });
          return true;
        }
      }
      return false;
    });
  }, [controlData]);
}
